import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MatchService } from '../../_core/services/match.service';
import { TimeItem } from '../../_shared/models/csTypes/time_item';
import { Match } from '../../_shared/models/match.model';
import { InfringementService } from '../infringement-list/infringement.service';

@Component({
  standalone: false,
  selector: 'app-violation-shortcuts',
  templateUrl: './violation-shortcuts.component.html',
  styleUrls: ['./violation-shortcuts.component.scss'],
})
export class ViolationShortcutsComponent implements OnInit, OnDestroy {
  @Input() match: Match;
  @Input() sideNumber: number;
  @Output() overrule: EventEmitter<number> = new EventEmitter();
  @Output() time: EventEmitter<number> = new EventEmitter();
  @Output() break: EventEmitter<number> = new EventEmitter();
  @Output() code: EventEmitter<number> = new EventEmitter();

  overrules: TimeItem[] = [];
  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    private infringementService: InfringementService,
    private matchService: MatchService
  ) { }

  ngOnInit() {    
    this.getOverrules();
    
    this.infringementService
      .subscribeUpdateViolations()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        match => {
          this.match = match
          this.getOverrules();
        }
      )

    this.matchService
      .subscribeScoreUpdated()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        match => {
          if (this.match._id === match._id) {
            this.match = match
            this.getOverrules();
          }
        }
      )
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }



  getOverrules() {
    this.overrules = this.match?.timeItems.filter(timeItem => { 
      if (timeItem.itemValue?.infringementType === 'OVERRULE' && timeItem.itemValue?.sideNumber === this.sideNumber) {
        return timeItem;
      } 
    });    
  }

}
